"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PrivacyOverview() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: text1Ref,
    isVisible: text1Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: text2Ref,
    isVisible: text2Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: text3Ref,
    isVisible: text3Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section id="privacy-overview" className="bg-background text-foreground py-24 md:py-32 lg:py-40">
      <div className="container mx-auto px-6 md:px-12 lg:px-24 max-w-4xl">
        {}
        <div ref={headlineRef} className="mb-12 md:mb-16 transition-all duration-500 ease-[var(--ease-smooth)]" style={{
        opacity: headlineVisible ? 1 : 0,
        transform: headlineVisible ? "translateY(0)" : "translateY(30px)"
      }}>
          <h1 className="text-[48px] md:text-[56px] lg:text-[64px] leading-[1.2] font-bold tracking-[-0.2px] text-foreground">
            Privacy Overview
          </h1>
        </div>

        {}
        <div ref={text1Ref} className="mb-8 transition-all duration-500 ease-[var(--ease-smooth)]" style={{
        opacity: text1Visible ? 1 : 0,
        transform: text1Visible ? "translateY(0)" : "translateY(20px)",
        transitionDelay: "0ms"
      }}>
          <p className="text-[18px] md:text-[20px] leading-[1.8] text-foreground/80 font-normal">
            Your privacy is important to us. This overview explains how we
            collect, use, and protect your personal information when you visit
            our website or use our services.
          </p>
        </div>

        {}
        <div ref={text2Ref} className="mb-8 transition-all duration-500 ease-[var(--ease-smooth)]" style={{
        opacity: text2Visible ? 1 : 0,
        transform: text2Visible ? "translateY(0)" : "translateY(20px)",
        transitionDelay: "50ms"
      }}>
          <p className="text-[18px] md:text-[20px] leading-[1.8] text-foreground/80 font-normal">
            We are committed to transparency in our data practices. We collect
            only the information necessary to provide you with the best possible
            experience, and we never sell your personal data to third parties.
          </p>
        </div>

        {}
        <div ref={text3Ref} className="transition-all duration-500 ease-[var(--ease-smooth)]" style={{
        opacity: text3Visible ? 1 : 0,
        transform: text3Visible ? "translateY(0)" : "translateY(20px)",
        transitionDelay: "100ms"
      }}>
          <p className="text-[18px] md:text-[20px] leading-[1.8] text-foreground/80 font-normal">
            By continuing to use our website, you acknowledge that you have read
            and understood our privacy practices. If you have any questions or
            concerns, please feel free to contact us at any time.
          </p>
        </div>
      </div>
    </section>;
}